export class UpdateUserPasswordEntity {
  userId;
  password;
  oldPassword;
  validateOldPassword;

  constructor(userId = "", password = "", oldPassword="",validateOldPassword= true) {
    this.userId = userId;
    this.password = password;
    this.oldPassword = oldPassword;
    this.validateOldPassword = validateOldPassword;
  }
}
